import Onboarding from "./Onboarding"
import Register from "./Register"
export const Surveys = {
    "register": Register,
    "onboarding": Onboarding
}